import gql from "graphql-tag";

const DEPARTURE_FIELDS = `
  id
  name
  startDate
  returnDate
  adults
  children
  brand
  department
  usedAdults
  remainingAdults
  usedChildren
  remainingChildren
  roomsAvailability
  roomsRemaining
  serviceStatusId
  internalStatus
  openGroup {
    id
    name
    brand
    department
    duration
    validFrom
    validTo
    departureDays
    destination {
      id
      name
    }
  }
`;

const ITEM_FIELDS = `
  id
  uid
  day
  duration
  order
  qty
  usedQty
  remainingQty
  adults
  children
  optional
  included
  hidden
  includeMarkup
  ratePlan
  parentUid
  service {
    id
    name
    typeName
    stdOccupancy
  }
  supplier {
    id
    name
    currencyCode
    serviceType
  }
  customPrice
  adultBuy
  adultSell
  childBuy
  childSell
  infantBuy
  infantSell
  itemBuy
  itemSell
  rateTypeCode
  currencyBuy
  currencySell
  remarks {
    agentNotes
    supplierNotes
    voucherNotes
    internalNotes
    pickupPoint
    pickupTime
    dropoffPoint
    dropoffTime
    roomNumbers
    timeFrom
    flightNo
    confirmationNo
  }
`;

export const OPEN_GROUP_DEPARTURES_QUERY = gql`
  query openGroupDepartures(
    $after: String
    $first: Int
    $filter: OpenGroupDepartureFilterType
    $orderBy: SortOrderType
  ) {
    openGroupDepartures(
      after: $after
      first: $first
      filter: $filter
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        node {
          ${DEPARTURE_FIELDS}
        }
      }
    }
  }
`;

export const OPEN_GROUP_DEPARTURE_QUERY = gql`
  query openGroupDeparture($id: ID!) {
    openGroupDeparture(id: $id) {
      ${DEPARTURE_FIELDS}
      items {
        ${ITEM_FIELDS}
      }
    }
  }
`;

export const CREATE_OPEN_GROUP_DEPARTURE = gql`
  mutation createOpenGroupDeparture(
    $openGroupId: ID!
    $openGroupDepartureInput: OpenGroupDepartureInput!
  ) {
    createOpenGroupDeparture(
      openGroupId: $openGroupId
      openGroupDepartureInput: $openGroupDepartureInput
    ) {
      ${DEPARTURE_FIELDS}
    }
  }
`;

export const CREATE_OPEN_GROUP_DEPARTURES_BULK = gql`
  mutation createOpenGroupDeparturesBulk($input: OpenGroupDeparturesBulkInput!) {
    createOpenGroupDeparturesBulk(input: $input) {
      departures {
        ${DEPARTURE_FIELDS}
      }
      skippedDates
    }
  }
`;

export const UPDATE_OPEN_GROUP_DEPARTURE = gql`
  mutation updateOpenGroupDeparture(
    $id: ID!
    $openGroupDepartureInput: OpenGroupDepartureInput!
  ) {
    updateOpenGroupDeparture(
      id: $id
      openGroupDepartureInput: $openGroupDepartureInput
    ) {
      ${DEPARTURE_FIELDS}
    }
  }
`;

export const DELETE_OPEN_GROUP_DEPARTURE = gql`
  mutation deleteOpenGroupDeparture($id: ID!) {
    deleteOpenGroupDeparture(id: $id) {
      id
    }
  }
`;

export const COPY_OPEN_GROUP_DEPARTURE_TO_DATE = gql`
  mutation copyOpenGroupDepartureToDate($id: ID!, $newStartDate: DateTimeType!) {
    copyOpenGroupDepartureToDate(id: $id, newStartDate: $newStartDate) {
      ${DEPARTURE_FIELDS}
    }
  }
`;

export const ADD_OPEN_GROUP_DEPARTURE_ITEM = gql`
  mutation addOpenGroupDepartureItem(
    $openGroupDepartureId: ID!
    $openGroupDepartureItemInput: OpenGroupDepartureItemInput!
  ) {
    addOpenGroupDepartureItem(
      openGroupDepartureId: $openGroupDepartureId
      openGroupDepartureItemInput: $openGroupDepartureItemInput
    ) {
      ${ITEM_FIELDS}
    }
  }
`;

export const UPDATE_OPEN_GROUP_DEPARTURE_ITEM = gql`
  mutation updateOpenGroupDepartureItem(
    $id: ID!
    $openGroupDepartureItemInput: OpenGroupDepartureItemInput!
  ) {
    updateOpenGroupDepartureItem(
      id: $id
      openGroupDepartureItemInput: $openGroupDepartureItemInput
    ) {
      ${ITEM_FIELDS}
    }
  }
`;

export const DELETE_OPEN_GROUP_DEPARTURE_ITEM = gql`
  mutation deleteOpenGroupDepartureItem($id: ID!) {
    deleteOpenGroupDepartureItem(id: $id) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/gt/open-groups/departure-gql.js